import { useDataSourceColumns } from "@/hooks";
import type { WhereTransformer } from "@/types/workspace";
import { Flex, Input, Select } from "@mantine/core";
import { useEffect, useState } from "react";
import { TransformerBase } from "./TransformerBase";

export function TransformerWhere({
  data,
  warning,
  error,
  onUpdate,
  index,
}: {
  data: WhereTransformer;
  warning?: string;
  error?: string;
  onUpdate?: (updatedData: WhereTransformer) => void;
  index: number;
}) {
  const firstKey = Object.keys(data.item_list[0])[0] || "";
  const [column, operator] = firstKey.split("__");
  const [columnState, setColumnState] = useState(column || "");
  const [operatorState, setOperatorState] = useState(operator || "eq");
  const [value, setValue] = useState(data.item_list[0][firstKey] || "");
  const availableColumns = useDataSourceColumns(index);

  useEffect(() => {
    const key = Object.keys(data.item_list[0])[0] || "";
    const [col, op] = key.split("__");
    setColumnState(col || "");
    setOperatorState(op || "eq");
    setValue(data.item_list[0][key] || "");
  }, [data.item_list]);

  const handleColumnChange = (value: string | null) => {
    if (value !== null) {
      setColumnState(value);
      if (onUpdate) {
        onUpdate({
          ...data,
          item_list: [
            {
              [`${value}__${operatorState}`]:
                data.item_list[0][Object.keys(data.item_list[0])[0]] || "",
            },
          ],
        });
      }
    }
  };

  const handleOperatorChange = (value: string | null) => {
    if (value !== null) {
      setOperatorState(value);
      if (onUpdate) {
        onUpdate({
          ...data,
          item_list: [{ [`${columnState}__${value}`]: value }],
        });
      }
    }
  };

  const handleValueChange = (val: string) => {
    setValue(val);
    if (onUpdate) {
      onUpdate({
        ...data,
        item_list: [{ [`${columnState}__${operatorState}`]: val }],
      });
    }
  };

  return (
    <TransformerBase warning={warning} error={error}>
      <Select
        placeholder="Column"
        data={availableColumns.length > 0 ? availableColumns : []}
        value={columnState}
        onChange={handleColumnChange}
        bg="#F1F3F4"
        bdrs="sm"
        variant="light"
      />
      <Flex direction="row" gap={8}>
        <Select
          bg="#F1F3F4"
          bdrs="sm"
          variant="light"
          placeholder="Operator"
          allowDeselect={false}
          data={[
            {
              label: "less than",
              value: "lt",
            },
            {
              label: "greater than",
              value: "gt",
            },
            {
              label: "equal to",
              value: "eq",
            },
            {
              label: "not equal to",
              value: "ne",
            },
            {
              label: "is null",
              value: "is_null",
            },
            {
              label: "is not null",
              value: "is_not_null",
            },
          ]}
          value={operatorState}
          onChange={handleOperatorChange}
        />
        <Input
          placeholder="Value"
          value={value}
          onChange={(e) => handleValueChange(e.target.value)}
          bg="#F1F3F4"
          bdrs="sm"
          variant="light"
        />
      </Flex>
    </TransformerBase>
  );
}
